import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import Seo from "../../../utils/seo/Seo";
import { GUIDES_ARTICLES, GUIDES_LIST } from "../../../utils/seo/guidesContent";
import { SITE_URL } from "../../../utils/seo/siteConfig";
import "../../components/seo/seoPages.css";

export default function GuideArticle() {
  const { slug } = useParams();
  const article = GUIDES_ARTICLES[slug];
  const meta = GUIDES_LIST.find((g) => g.slug === slug);

  if (!article || !meta) return <Navigate to="/guides" replace />;

  const path = `/guides/${slug}`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.h1,
    description: meta.description,
    datePublished: article.published,
    author: { "@type": "Organization", name: "WillAlwaysLoveU" },
    mainEntityOfPage: `${SITE_URL}${path}`,
  };

  return (
    <>
      <Seo title={meta.title} description={meta.description} path={path} type="article" jsonLd={jsonLd} />
      <article className="seo-page">
        <p>
          <Link to="/guides">← Back to guides</Link>
        </p>
        <h1>{article.h1}</h1>
        {article.intro && <p className="seo-intro">{article.intro}</p>}
        {article.sections.map((s, index) => (
          <section key={s.h2 || `section-${index}`}>
            {s.h2 && <h2>{s.h2}</h2>}
            <p>{s.body}</p>
          </section>
        ))}
        <div className="seo-cta">
          <Link to={article.cta.to}>{article.cta.label}</Link>
        </div>
      </article>
    </>
  );
}
